module.exports = __webpack_public_path__ + "435047c53a039bea51373464bb06026a.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-decoration-1.png
// module id = 473
// module chunks = 0